import styled from 'styled-components'

export const EllipsisText = styled.p`
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
